import React from 'react';
import {
  Plus,
  Trash2,
  Camera,
  X,
  Link as LinkIcon,
} from 'lucide-react';
import { normalizeUrl } from '../pages/admin/linksConfig.utils';
import { InfoTip } from './LinksConfigUi';

export default function LinksConfigExternalLinksPanel({
  externalLinks,
  externalUploadError,
  uploadingImage,
  isUploadingImage,
  handleExternalImageSelect,
  removeExternalLinkImage,
  updateExternalLink,
  removeExternalLink,
  newLink,
  setNewLink,
  canAdd,
  addExternalLink,
}) {
  return (
          <section className="fsl-card">
            <div className="fsl-card-head">
              <h2 className="fsl-card-title">
                Links externos
                <InfoTip text="Adicione outros links importantes: Instagram, iFood, site, WhatsApp..." />
              </h2>
              <span className="fsl-count-chip">{externalLinks.length}</span>
            </div>

            {externalUploadError && (
              <p className="fsl-upload-error">{externalUploadError}</p>
            )}

            {externalLinks.length > 0 && (
              <div className="fsl-ext-list">
                {externalLinks.map((link) => {
                  const externalUploadKey = `external:${link.id}`;
                  return (
                    <div key={link.id} className="fsl-ext-row">
                      <div className="fsl-ext-thumb-wrap">
                        <label
                          className={`fsl-ext-thumb ${link.image ? 'has-img' : ''} ${uploadingImage === externalUploadKey ? 'is-loading' : ''} ${isUploadingImage ? 'is-disabled' : ''}`}
                          title={link.image ? 'Trocar imagem do link' : 'Adicionar imagem do link'}
                        >
                          {link.image ? (
                            <img src={link.image} alt="" aria-hidden="true" />
                          ) : (
                            <LinkIcon size={16} strokeWidth={2.2} aria-hidden="true" />
                          )}
                          <span className="fsl-ext-thumb-cam" aria-hidden>
                            <Camera size={12} strokeWidth={2.5} />
                          </span>
                          <input
                            type="file"
                            accept="image/jpeg,image/png,image/webp"
                            disabled={isUploadingImage}
                            onChange={(event) => {
                              const file = event.target.files?.[0];
                              event.target.value = '';
                              handleExternalImageSelect(link.id, file);
                            }}
                          />
                        </label>
                        {link.image && (
                          <button
                            type="button"
                            className="fsl-ext-thumb-remove"
                            onClick={() => removeExternalLinkImage(link.id)}
                            disabled={isUploadingImage}
                            title="Remover imagem"
                            aria-label="Remover imagem"
                          >
                            <X size={11} strokeWidth={2.8} />
                          </button>
                        )}
                      </div>
                      <div className="fsl-ext-fields">
                        <div className="fsl-ext-label-field">
                          <input
                            className="fsl-mini-input fsl-ext-label"
                            value={link.label}
                            onChange={(event) =>
                              updateExternalLink(link.id, { label: event.target.value })
                            }
                            placeholder="Nome do botão"
                            maxLength={60}
                          />
                          <span>Até 30 caracteres costuma ficar em uma linha; acima disso, o botão pode quebrar. {link.label.length}/60</span>
                        </div>
                        <input
                          className="fsl-mini-input fsl-ext-url"
                          value={link.url}
                          onChange={(event) =>
                            updateExternalLink(link.id, { url: event.target.value })
                          }
                          onBlur={(event) =>
                            updateExternalLink(link.id, { url: normalizeUrl(event.target.value) })
                          }
                          placeholder="https://..."
                        />
                      </div>
                      <button
                        type="button"
                        className="fsl-icon-btn fsl-icon-btn--danger"
                        onClick={() => removeExternalLink(link.id)}
                        title="Remover link"
                        aria-label="Remover link"
                      >
                        <Trash2 size={16} strokeWidth={2.2} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="fsl-ext-add">
              <div className="fsl-ext-add-fields">
                <div className="fsl-ext-label-field">
                  <input
                    className="fsl-input"
                    value={newLink.label}
                    onChange={(event) => setNewLink((current) => ({ ...current, label: event.target.value }))}
                    placeholder="Nome do botão (ex.: Nosso Instagram)"
                    maxLength={60}
                  />
                  <span>Até 30 caracteres costuma ficar em uma linha; acima disso, o botão pode quebrar. {newLink.label.length}/60</span>
                </div>
                <input
                  className="fsl-input"
                  value={newLink.url}
                  onChange={(event) => setNewLink((current) => ({ ...current, url: event.target.value }))}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' && canAdd) addExternalLink();
                  }}
                  placeholder="URL do link (ex.: instagram.com/seurestaurante)"
                />
              </div>
              <button
                type="button"
                className="fsl-add-btn"
                onClick={addExternalLink}
                disabled={!canAdd}
              >
                <Plus size={18} strokeWidth={2.6} />
                Adicionar link
              </button>
            </div>
          </section>
  );
}
